<template>
  <pt-order-detail class="pt-order-detail__withData" :id="id" :orderDetail="orderDetail" @goodsOrderDetail="goodsOrderDetail" ref="detail" :submit-loading="submit_loading"
  :loading="loading" :orderHistoryList="orderHistoryList" :operation="operation" :orderStatesArray="orderStatesArray" @closeOrder="closeOrder" @getRefundmentReason="getRefundmentReason"
  :refundReasonList="refundReasonList" :refundReasonLoading="refundReasonLoading" :invoiceList="invoiceList" @downloadInvoice="downloadInvoice"
  @refreshDetail="refreshDetail" :registrationEvent="registrationEvent" :userRegistration="userRegistration"
  :userPoints="userPoints"></pt-order-detail>
</template>

<script>
import PtOrderDetail from './index'

import { getEnumeration } from 'enumeration'
export default {
  name: 'pt-order-detail__withData',
  props: {
    id: {
      type: String,
      default: ''
    },
    operation: {
      type: String,
      default: ''
    }
  },
  watch: {
    id (val) {
      this.goodsOrderDetail()
      this.getOrderProgress()
      this.getOrderInvoices()
      this.getOrderHistory()
      this.getRefundmentReason()
    }
  },
  components: {
    'pt-order-detail': PtOrderDetail
  },
  computed: {
    form () {
      return this.$refs.detail
    },
    goodsTypeList () {
      return this.$store.state.goodsTypeList || []
    },
    orderUserLogin () {
      return this.orderDetail.placeUserRoleInformation && this.orderDetail.placeUserRoleInformation.userLogin
    }
  },
  data () {
    return {
      orderDetail: {},
      submit_loading: false,
      loading: false,
      orderStatesArray: null,
      refundReasonList: [],
      refundReasonLoading: false,
      invoiceList: [],
      userRegistration: {},
      registrationEvent: {},
      userPoints: null,
      orderHistoryList: []
    }
  },
  methods: {
    // 获取退款原因列表
    getRefundmentReason () {
      let data = {
        type: 'RefundmentReason'
      }
      this.refundReasonLoading = true
      this.$store.dispatch('getRefundmentReason', data).then(res => {
        this.refundReasonLoading = false
        this.refundReasonList = res
      }).catch(err => {
        this.refundReasonLoading = false
        this.$message(err || '获取退款原因失败')
      })
    },
    closeOrder () {
      this.$store.dispatch('closeOrder', this.id).then(res => {
        this.$message.success('关闭订单成功')
        this.goodsOrderDetail()
        this.getOrderProgress()
      }).catch(err => {
        this.$message.error(err || '关闭订单失败')
      })
    },
    refreshDetail () {
      this.goodsOrderDetail()
    },
    goodsOrderDetail () {
      this.loading = true
      this.$store.dispatch('goodsOrderDetail', this.id).then(res => {
        this.orderDetail = res.mallOrder
        this.userRegistration = res.userRegistration
        this.registrationEvent = res.registrationEvent
        let goods = this.orderDetail.goods && this.orderDetail.goods[0]
        if (this.goodsTypeList.length > 0) {
          this.orderDetail.goods_type = (goods && goods.type && getEnumeration(goods.type, this.goodsTypeList, 'name')) || null
        } else {
          this.getGoodsTypes()
        }
        this.loading = false

        this.getUserIntegral()
      }).catch(err => {
        this.$message.error(err || '获取订单详情失败')
        this.loading = false
      })
    },

    // 获取商品类型列表
    getGoodsTypes () {
      return this.$store.dispatch('getGoodsTypes').then(_ => {
        this.$nextTick(_ => {
          this.$set(this.orderDetail, 'goods_type', (this.orderDetail && this.orderDetail.goods && this.orderDetail.goods[0] && this.orderDetail.goods[0].type && getEnumeration(this.orderDetail.goods[0].type, this.goodsTypeList, 'name')) || null)
        })
      })
    },
    getOrderProgress () {
      this.$store.dispatch('getOrderProgress', this.id).then(res => {
        this.orderStatesArray = res.items
      }).catch(err => {
        this.$message.error(err || '获取订单状态失败')
      })
    },
    // 根据订单id获取相关发票信息
    getOrderInvoices () {
      this.$store.dispatch('getOrderInvoice', this.id).then(res => {
        this.invoiceList = res
      }).catch(err => {
        this.$message.error(err || '获取发票信息失败')
      })
    },
    // 下载发票(使用的id是订单id)
    downloadInvoice () {
      location.href = this.$apiServer + '/mallsales/api/invoice/' + this.id
    },
    // 获取订单用户积分余额
    getUserIntegral () {
      this.$store.dispatch('getUserIntegral', this.orderUserLogin).then(res => {
        console.log('res++', res)
        this.userPoints = res.consumedPointsValid
      }).catch(err => {
        this.$message.error(err || '获取用户积分余额失败')
      })
    },
    // 获取订单历史记录
    getOrderHistory () {
      this.$store.dispatch('getOrderHistory', this.id).then(res => {
        console.log('111111111111', res)
        this.orderHistoryList = res
      }).catch(err => {
        this.$message.error(err || '获取订单历史记录失败')
      })
    }
  },
  created () {
    if (this.id) {
      this.goodsOrderDetail()
      this.getOrderProgress()
      this.getOrderInvoices()
      this.getOrderHistory()
    }
    this.getRefundmentReason()
  }
}
</script>
